import {
  Box,
  Button,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  customerCodes,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Customer No
        </InputLabel>
        <Autocomplete
          disablePortal
          options={customerCodes}
          getOptionLabel={(option) => option.customer_no}
          value={
            filterData.customerNo
              ? customerCodes.find(
                  (b) => b.customer_no === filterData.customerNo
                )
              : null
          }
          onChange={(_, newValue) => {
            // Store customer_no in state
            handleChangeFilter("customerNo")(
              null,
              newValue ? newValue.customer_no : ""
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Customer No"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
